import { render, staticRenderFns } from "./InvolvementDetails.vue?vue&type=template&id=7e417b5d"
import script from "./InvolvementDetails.vue?vue&type=script&lang=js"
export * from "./InvolvementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports